import { Stack, SxProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CommandTypeEnum, getCommandTypeDisplayName } from '~enums/commandTypeEnum';
import { BaseReference } from '~interfaces';
import { Dimens } from '~themes';

import Dropdown from './dropdown';

interface ActionRelaysDropdownProps {
	selectedValue?: BaseReference;
	onValueChanged: (newValue?: BaseReference) => void;
	disableClearable?: boolean;
	relayNumber: 1 | 2;
	label?: string;
	sx?: SxProps;
}

const ActionRelaysDropDown = ({
	selectedValue,
	label,
	sx,
	relayNumber,
	...props
}: ActionRelaysDropdownProps) => {
	const { t } = useTranslation();

	// Data
	const allActionRelays = (
		relayNumber == 1 ?
			[
				CommandTypeEnum.ControllerRelay1Pulse,
				CommandTypeEnum.ControllerRelay1Toggle,
				CommandTypeEnum.ControllerRelay1Follow,
				CommandTypeEnum.ControllerRelay1On,
				CommandTypeEnum.ControllerRelay1Off,
			]
		:	[
				CommandTypeEnum.ControllerRelay2Pulse,
				CommandTypeEnum.ControllerRelay2Toggle,
				CommandTypeEnum.ControllerRelay2Follow,
				CommandTypeEnum.ControllerRelay2On,
				CommandTypeEnum.ControllerRelay2Off,
			]).map(
		(actionRelay) =>
			({
				id: actionRelay as string,
				name: getCommandTypeDisplayName(actionRelay, t),
			}) as BaseReference
	);

	const handleOptionSelected = (value: BaseReference | null) => {
		props.onValueChanged({
			id: value?.id ?? '',
			name: value?.name ?? '',
		});
	};

	// Component
	return (
		<Stack spacing={Dimens.spacingXs} sx={sx}>
			{label && <Typography variant='labelSm'>{label}</Typography>}
			<Dropdown
				value={selectedValue}
				placeholder={t('general.none', { ns: 'entities' })}
				values={allActionRelays}
				canClear={true}
				onValueChanged={handleOptionSelected}
			/>
		</Stack>
	);
};

export default ActionRelaysDropDown;
